export default "__VITE_ASSET__BPccjtXw__"